import { Component, OnInit, Input, Injector } from '@angular/core';
import {
  ControlContainer,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { AttributeValidatorModel } from '@app/shared/interfaces/Attribute';

@Component({
  selector: 'app-attribute-validators',
  templateUrl: './attribute-validators.component.html',
  styleUrls: ['./attribute-validators.component.less'],
})
export class AttributeValidatorsComponent
  extends BaseComponent
  implements OnInit
{
  @Input() formGroup: FormGroup;
  @Input() attributeId: number = 0;
  validatorsFormArray: FormArray;

  private _validators: AttributeValidatorModel[] = [];
  public get validators(): AttributeValidatorModel[] {
    return this._validators;
  }
  @Input()
  public set validators(value: AttributeValidatorModel[]) {
    this._validators = value;
    this.validatorsFormArray = this.fb.array([]);
    this.assignAttributeValidators();
  }

  constructor(injector: Injector, private controlContainer: ControlContainer) {
    super(injector);
    this.validatorsFormArray = this.fb.array([]);
  }

  ngOnInit() {
    this.validatorsFormArray = this.fb.array([]);
    // this.validatorsFormArray = this.controlContainer.control as FormArray;
    setTimeout(() => {
      this.assignAttributeValidators();
      // console.log(
      //   'ngOnInit ~ this.validatorsFormArray:',
      //   this.validatorsFormArray
      // );
    }, 1000);
  }

  private assignAttributeValidators() {
    const assignedValidators = this.validatorsFormArray.controls;
    if (assignedValidators != null) {
      this.validators.forEach((val) => {
        const validator = assignedValidators.find(
          (x) => x.value.ValidatorType == val.code
        );
        if (validator == null) {
          this.validatorsFormArray.controls = [
            ...this.validatorsFormArray.controls,
            this.fb.group({
              Id: 0,
              AttributeId: new FormControl(this.attributeId ?? 0),
              ValidatorType: new FormControl(val.code),
              ValidatorContent: new FormControl(''),
            }),
          ];
        }
      });
    }
    this.validatorsFormArray.controls.forEach((x) => {
      this.subscriptions.push(
        x.valueChanges.subscribe(() => {
          this.formGroup.markAsDirty();
          this.formGroup.markAsTouched();
        })
      );
    });
  }
}
